import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CheckboxSelector from "../../../components/CheckboxSelector";
import IconComponent from "../../../../../components/DataTable/Icon";
import React from "react";
import classNames from "classnames";
import moment from "moment";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";

const TABLE_HEADERS = [
  "Provider",
  "Zone",
  "Schedule Type",
  "Working Pattern",
  // "Working Hours",
  // "Target Visits/Day",
  // "Appointment Types",
  "Current Status",
  "Upcoming Leaves",
];

const WELCOME_TABLE_HEADERS = [
  "Name",
  "Speciality",
  "Visit per Day",
  "Availability",
  "Absence",
  "",
];

const DAY_MAP = {
  MONDAY: "M",
  TUESDAY: "T",
  WEDNESDAY: "W",
  THURSDAY: "Th",
  FRIDAY: "F",
  SATURDAY: "Sa",
  SUNDAY: "Su",
};

const DAY_ORDER = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];

const sortWorkingDays = (days) => {
  if (!Array.isArray(days)) return days;
  return [...days].sort((a, b) => {
    const indexA = DAY_ORDER.indexOf(a);
    const indexB = DAY_ORDER.indexOf(b);
    // If day not found in order, put it at the end
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    return indexA - indexB;
  });
};

const ProviderTable = ({
  providers,
  handleEditClick,
  selectProvider,
  selectAllProviders,
  visitPerDaySort,
  handleVisitPerDaySort,
  isGlobalShow = true,
  setIsCalenderOpen,
  setProviderIsAv,
  isWelComePage,
  user = {}
}) => {
  const parseNull = (value, replacement = "NA", type = "string") => {
    return value === null || (Array.isArray(value) && value.length === 0)
      ? replacement
      : Array.isArray(value)
        ? value.map((day) => DAY_MAP[day]).join(", ")
        : type === "date"
          ? moment(value).format("MM/DD/YYYY")
          : value;
  };
  return (
    <>
      {isWelComePage ? (
        <div
          className={
            isGlobalShow
              ? "h-screen overflow-scroll no-scrollbar"
              : "overflow-auto max-h-96 min-h-40"
          }
        >
          <table className={(!isGlobalShow ? "" : "mb-[100px]") + " w-full "}>
            <thead>
              <tr className="bg-primarylightgrey">
                {isGlobalShow &&
                  TABLE_HEADERS.map((header, index) => (
                    <th key={index} className="px-4 py-3 text-base">
                      <div className="flex flex-row items-center">
                        <p className="m-0">{header}</p>
                      </div>
                    </th>
                  ))}
                {!isGlobalShow &&
                  WELCOME_TABLE_HEADERS.map((header, index) => (
                    <>
                      <th key={index} className="px-4 py-3 text-base">
                        <div className="flex flex-row items-center">
                          <p className="m-0">{header}</p>
                        </div>
                      </th>
                    </>
                  ))}
              </tr>
            </thead>
            {providers.length > 0 ? (
              <tbody>
                {!isGlobalShow &&
                  providers.map((provider) => (
                    <tr className="text-base border-bottom" key={provider.id}>
                      <td className="px-4 py-3 text-left">{provider.name}</td>
                      <td className="px-4 py-3 text-left">
                        {provider.speciality}
                      </td>
                      <td className="px-4 py-3 text-left">
                        {parseNull(provider.visitsPerDay)}
                      </td>
                      <td className="px-4 py-3 text-left">
                        {parseNull(provider.workingDays)}
                      </td>
                      <td className="px-4 py-3 text-left">
                        <div className="flex flex-row justify-center gap-2">
                          {provider.ptos}
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <button
                          className="p-2 text-white bg-gray-200 rounded-md"
                          onClick={() => {
                            handleEditClick(provider.id);
                          }}
                        >
                          <IconComponent
                            tooltip={"Edit"}
                            icon="Edit_Icon"
                            i={provider.id}
                            key={provider.id}
                          />
                        </button>
                      </td>
                    </tr>
                  ))}
                {isGlobalShow &&
                  providers.map((provider) => (
                    <tr className="text-base border-b" key={provider.id}>
                      <td className="px-4 py-3 whitespace-nowrap">
                        <div className="flex items-center gap-2">
                          <div>
                            <b>{provider.name}</b>
                            <br />
                            <span className="text-sm text-gray-500">
                              {provider.speciality}
                            </span>
                          </div>
                          {user?.permissions?.includes('provider_settings.edit_provider_settings') && <button
                            className="p-2 text-white rounded-md"
                            onClick={() => {
                              handleEditClick(provider.id);
                              setProviderIsAv(provider.id);
                            }}
                          >
                            <IconComponent
                              tooltip={"Edit"}
                              icon="Edit_Icon"
                              i={provider.id}
                              key={provider.id}
                            />
                          </button>}
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex flex-col gap-2">
                          {provider?.zones?.length > 0
                            ? provider?.zones?.map((zone) => {
                              return (
                                <span
                                  key={zone.id}
                                  className="py-1 px-2 bg-[#f3f4f6] text-[#374151] font-medium rounded-md p-1 items-center justify-center whitespace-nowrap"
                                >
                                  {zone.name}
                                </span>
                              );
                            })
                            : "NA"}
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex flex-col items-start justify-center gap-2">
                          <span
                            className={classNames(
                              "py-1 px-2 rounded-md p-1 items-center justify-center font-medium whitespace-nowrap",
                              provider?.schedule_type === "Weekly"
                                ? "bg-[#f0fdf4] text-[#166534]"
                                : "bg-[#fef3c7] text-[#92400e]"
                            )}
                          >
                            {provider?.schedule_type}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-center">
                        <div className="flex flex-row gap-2">
                          {sortWorkingDays(provider.workingDays)?.map((day) => {
                            return (
                              <span
                                key={day}
                                className="py-1 px-2 bg-[#dbeafe] text-[#1e40af] rounded-lg font-medium"
                              >
                                {DAY_MAP[day]}
                              </span>
                            );
                          })}
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          <span
                            className={classNames(
                              "w-[10px] h-[10px] rounded-full",
                              provider?.current_status === "Available"
                                ? "bg-green-500"
                                : provider?.current_status === "Limited"
                                  ? "bg-[#f59e0b]"
                                  : "bg-[#ef4444]"
                            )}
                          ></span>
                          <span className="text-medium">
                            {provider?.current_status}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        {provider?.leaves?.length > 0 ? (
                          provider?.leaves?.filter((leave) =>
                            moment(leave.end_date).isSameOrAfter(moment(), "day") // ✅ keep current or future leaves only
                          )?.map((leave) => {
                            const isLeaveDay = moment().isBetween(
                              moment(leave.start_date),
                              moment(leave.end_date),
                              "day",
                              "[]"
                            );
                            return (
                              <div
                                key={leave.id}
                                className="flex items-center gap-2"
                              >
                                <span
                                  className={classNames(
                                    "w-[8px] h-[8px] rounded-full",
                                    isLeaveDay
                                      ? "bg-[#ef4444]"
                                      : "bg-[#f59e0b]"
                                  )}
                                ></span>
                                <span className="text-[#6b7280]">
                                  {moment(leave.start_date).format("MMM DD")}{" "}
                                  - {moment(leave.end_date).format("MMM DD")}
                                </span>
                              </div>
                            );
                          })
                        ) : (
                          <div className="flex items-center gap-2">
                            <span className="text-[#6b7280]">
                              None scheduled
                            </span>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            ) : (
              <tbody className="relative">
                <div
                  className="absolute w-full py-2 my-3 d-flex align-Items-center justify-content-center"
                  style={{ zIndex: 0 }}
                >
                  <p className="text-xl font-bold text-primarygrayborder">
                    {" "}
                    No Records Found
                  </p>
                </div>
              </tbody>
            )}
          </table>
        </div>
      ) : (
        <div className="w-full px-16">
          <div className="relative w-full mt-8 mb-2 overflow-x-auto overflow-y-auto bg-white rounded-lg shadow max-h-[calc(100vh-270px)]">
            <table className={(!isGlobalShow ? "" : "mb-[100px]") + " w-full "}>
              <thead>
                <tr className="h-16 text-base font-bold text-left text-white bg-primaryblue whitespace-nowrap">
                  {isGlobalShow &&
                    TABLE_HEADERS.filter((header) => header !== "Zone").map((header, index) => (
                      <th key={index} className="px-4 py-3 text-base">
                        <div className="flex flex-row items-center">
                          <p className="m-0">{header}</p>
                        </div>
                      </th>
                    ))}
                  {!isGlobalShow &&
                    WELCOME_TABLE_HEADERS.map((header, index) => (
                      <>
                        <th key={index} className="px-4 py-3 text-base">
                          <div className="flex flex-row items-center">
                            <p className="m-0">{header}</p>
                          </div>
                        </th>
                      </>
                    ))}
                </tr>
              </thead>
              {providers.length > 0 ? (
                <tbody>
                  {!isGlobalShow &&
                    providers.map((provider) => (
                      <tr className="text-base border-b" key={provider.id}>
                        <td className="px-4 py-3 text-left">{provider.name} </td>
                        <td className="px-4 py-3 text-left">
                          {provider.speciality}
                        </td>
                        <td className="px-4 py-3 text-left">
                          {parseNull(provider.visitsPerDay)}
                        </td>
                        <td className="px-4 py-3 text-left">
                          {parseNull(provider.workingDays)}
                        </td>
                        <td className="px-4 py-3 text-left">
                          <div className="flex flex-row justify-center gap-2">
                            {provider.ptos}
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <button
                            className="p-2 text-white rounded-md"
                            onClick={() => {
                              handleEditClick(provider.id);
                            }}
                          >
                            <IconComponent
                              tooltip={"Edit"}
                              icon="Edit_Icon"
                              i={provider.id}
                              key={provider.id}
                            />
                          </button>
                        </td>
                      </tr>
                    ))}
                  {isGlobalShow &&
                    providers.map((provider) => (
                      <tr className="text-base border-b" key={provider.id}>
                        <td className="px-4 py-3 whitespace-nowrap">
                          <div className="flex items-center gap-2">
                            <div>
                              <span className="d-flex gap-2">
                                <b>{provider.name} </b>
                                {(!provider.location?.lat && !provider.location?.lng) || (provider?.qualification == null) ? (
                                  <button

                                    className="bg-yellow-50 gap-1 text-yellow-600 border-[1px] flex items-center justify-center border-primaryyellow rounded-md px-2"
                                  >
                                    <WarningRoundedIcon
                                      style={{
                                        fontSize: "16px",
                                      }}
                                    />
                                    <p className="m-0 text-sm">Missing Data Points</p>
                                  </button>) : ""}
                              </span>
                              {/* <br /> */}
                              <span className="text-sm text-gray-500">
                                {provider.speciality}
                              </span>
                            </div>
                            <button
                              className="p-2 text-white rounded-md self-start"
                              onClick={() => {
                                handleEditClick(provider.id);
                                setProviderIsAv(provider.id);
                              }}
                            >
                              <IconComponent
                                tooltip={"Edit"}
                                icon="Edit_Icon"
                                i={provider.id}
                                key={provider.id}
                              />
                            </button>
                          </div>
                        </td>
                        {/* <td className="px-4 py-3">
                          <div className="flex flex-col gap-2">
                            {provider?.zones?.length > 0
                              ? provider?.zones?.map((zone) => {
                                  return (
                                    <span
                                      key={zone.id}
                                      className="py-1 px-2 bg-[#f3f4f6] text-[#374151] font-medium rounded-md p-1 items-center justify-center whitespace-nowrap"
                                    >
                                      {zone.name}
                                    </span>
                                  );
                                })
                              : "NA"}
                          </div>
                        </td> */}
                        <td className="px-4 py-3">
                          <div className="flex flex-col items-start justify-center gap-2">
                            <span
                              className={classNames(
                                "py-1 px-2 rounded-md p-1 items-center justify-center font-medium whitespace-nowrap",
                                provider?.schedule_type === "Weekly"
                                  ? "bg-[#f0fdf4] text-[#166534]"
                                  : "bg-[#fef3c7] text-[#92400e]"
                              )}
                            >
                              {provider?.schedule_type}
                            </span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <div className="flex flex-row gap-2">
                            {sortWorkingDays(provider.workingDays)?.map((day) => {
                              return (
                                <span
                                  key={day}
                                  className="py-1 px-2 bg-[#dbeafe] text-[#1e40af] rounded-lg font-medium"
                                >
                                  {DAY_MAP[day]}
                                </span>
                              );
                            })}
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <span
                              className={classNames(
                                "w-[10px] h-[10px] rounded-full",
                                provider?.current_status === "Available"
                                  ? "bg-green-500"
                                  : provider?.current_status === "Limited"
                                    ? "bg-[#f59e0b]"
                                    : "bg-[#ef4444]"
                              )}
                            ></span>
                            <span className="text-medium">
                              {provider?.current_status}
                            </span>
                          </div>
                        </td>
                        {/* <td className="px-4 py-3">
                          {provider?.leaves?.length > 0 ? (
                            provider?.leaves?.map((leave) => {
                              const isLeaveDay = moment().isBetween(
                                moment(leave.start_date),
                                moment(leave.end_date),
                                "day",
                                "[]"
                              );
                              return (
                                <div
                                  key={leave.id}
                                  className="flex items-center gap-2"
                                >
                                  <span
                                    className={classNames(
                                      "w-[8px] h-[8px] rounded-full",
                                      isLeaveDay
                                        ? "bg-[#ef4444]"
                                        : "bg-[#f59e0b]"
                                    )}
                                  ></span>
                                  <span className="text-[#6b7280]">
                                    {moment(leave.start_date).format("MMM DD")}{" "}
                                    - {moment(leave.end_date).format("MMM DD")}
                                  </span>
                                </div>
                              );
                            })
                          ) : (
                            <div className="flex items-center gap-2">
                              <span className="text-[#6b7280]">
                                None scheduled
                              </span>
                            </div>
                          )}
                        </td> */}

                        <td className="px-4 py-3">
                          <div className="max-h-24 overflow-y-auto no-scrollbar"> {/* Fixed height and scrollable */}
                            {provider?.leaves?.length > 0 ? (
                              provider?.leaves?.filter((leave) =>
                                moment(leave.end_date).isSameOrAfter(moment(), "day")
                              ).map((leave) => {
                                const isLeaveDay = moment().isBetween(
                                  moment(leave.start_date),
                                  moment(leave.end_date),
                                  "day",
                                  "[]"
                                );
                                return (
                                  <div
                                    key={leave.id}
                                    className="flex items-center gap-2 py-1" // Added vertical padding
                                  >
                                    <span
                                      className={classNames(
                                        "w-[8px] h-[8px] rounded-full flex-shrink-0", // Prevent icon from shrinking
                                        isLeaveDay
                                          ? "bg-[#ef4444]"
                                          : "bg-[#f59e0b]"
                                      )}
                                    ></span>
                                    <span className="text-[#6b7280] text-sm whitespace-nowrap"> {/* Smaller text and prevent wrapping */}
                                      {moment(leave.start_date).format("MMM DD")}{" "}
                                      - {moment(leave.end_date).format("MMM DD")}
                                    </span>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="flex items-center gap-2 py-1">
                                <span className="text-[#6b7280] text-sm">
                                  None scheduled
                                </span>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              ) : (
                <tbody className="relative">
                  <div
                    className="absolute w-full py-2 my-3 d-flex align-Items-center justify-content-center"
                    style={{ zIndex: 0 }}
                  >
                    <p className="text-xl font-bold text-primarygrayborder">
                      {" "}
                      No Records Found
                    </p>
                  </div>
                </tbody>
              )}
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export default ProviderTable;
